export const listCards = `
   query listCards($filter: CardsFilterInput, $limit: Int, $nextToken: String) {
       listCards(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              customerId
              last4
              expMonth
              expYear
              name
              country
           }
           nextToken
       }
   }
`;

export const getCard = `
   query getCard($customerId: ID!, $id:ID!) {
       getCard(customerId:$customerId, id:$id) {
         id
         customerId
         last4
         expMonth
         expYear
         name
         country
       }
}`;
